import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { TrendingUp } from 'lucide-react';

export default function UpgradeLimitPrompt({ isOpen, onClose, message = 'You have reached your plan limit.' }) {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[420px] bg-white" data-testid="upgrade-limit-prompt">
        <DialogHeader>
          <div className="flex flex-col items-center gap-3 pt-2">
            <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-amber-600" />
            </div>
            <DialogTitle className="text-lg font-semibold text-gray-900 text-center">
              Plan Limit Reached
            </DialogTitle>
          </div>
        </DialogHeader>
        <div className="py-3 text-center">
          <p className="text-sm text-gray-600">{message}</p>
          <p className="text-sm text-gray-500 mt-2">
            Upgrade your plan to unlock higher limits and continue growing.
          </p>
        </div>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-3">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto" data-testid="upgrade-limit-dismiss-btn">
            Got it
          </Button>
          <Button
            onClick={() => { onClose(); navigate('/settings?tab=billing'); }}
            className="w-full sm:w-auto bg-teal-500 hover:bg-teal-600 text-white"
            data-testid="upgrade-limit-upgrade-btn"
          >
            Upgrade Plan
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
